import React from "react";
import { Card, Row, Col, ListGroup, Button } from "react-bootstrap";
import { SpinnerBlock } from "../../../Utils/CustomComponent";
function OverDueNextDue({ overdueNextDue }) {
  return (
    <div className="ps-3">
      <Card
        style={{
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
        className="border border-primary p-2"
      >
        <Card.Header style={{ fontWeight: "bold" }}>Other Details</Card.Header>
        {overdueNextDue?.[0] ? (
          <Card.Body className="p-3">
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Next Installment Due Date</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.duedate || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Reserve Balance</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.reserve_balance || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Impound Balance</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.impound_balance || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Current Principal and Interest Due</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.current_pi_due || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Unpaid Late Charges</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.unpaid_late_charges || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Unpaid Interest</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.unpaid_interest || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Reserve Payment</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.reserve_payment || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Impound Payment</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.impound_payment || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong> Other Charges</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.other_charges || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Current Total Amount Due</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.current_total_amount_due || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    <strong>Loan Stop Date</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{ padding: "0", border: "none" }}
                    className="p-3"
                  >
                    : {overdueNextDue?.[0]?.stop_date || " - "}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
          </Card.Body>
        ) : (
          <div>
            <SpinnerBlock />
          </div>
        )}
      </Card>
    </div>
  );
}

export default OverDueNextDue;
